'use client';

import { motion } from 'motion/react';

export default function Roles() {
  const roles = [
    {
      level: "LEVEL 01",
      title: "Org Owner",
      items: ["FULL SYSTEM ACCESS", "GLOBAL BILLING", "MASTER BRANDING", "ECOSYSTEM DATA"]
    },
    {
      level: "LEVEL 02",
      title: "Fed Manager",
      items: ["REGION ADMIN", "SANCTIONING", "FED REVENUE", "STAFF ROLES"]
    },
    {
      level: "LEVEL 03",
      title: "Comp Admin",
      items: ["RULEBOOK EDIT", "SCHEDULING", "REF MANAGEMENT", "SCORE APPROVAL"]
    },
    {
      level: "LEVEL 04",
      title: "Team Manager",
      items: ["ROSTER CONTROL", "TEAM PROFILE", "REGISTRATION", "PLAYER COMM"]
    },
    {
      level: "LEVEL 05",
      title: "Player",
      items: ["PROFILE BIO", "STAT HISTORY", "ACHIEVEMENT", "ATTENDANCE"]
    }
  ];

  return (
    <section className="bg-[#141414] py-24 px-6 md:px-12 lg:px-24 border-y border-zinc-800/50">
      <div className="mx-auto max-w-7xl">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
          className="mb-12"
        >
          <h2 className="mb-4 text-3xl font-black tracking-tight text-white md:text-4xl">
            Command & Control
          </h2>
          <p className="text-sm text-zinc-400">
            Granular role-based permissions for enterprise efficiency.
          </p>
        </motion.div>

        <div className="grid gap-4 sm:grid-cols-2 lg:grid-cols-5">
          {roles.map((role, index) => (
            <motion.div
              key={index}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.5, delay: index * 0.1 }}
              className="rounded-lg border border-zinc-800 bg-[#0a0a0a] p-6"
            >
              <div className="mb-4 text-[10px] font-bold tracking-widest text-[#b4ff00]">
                {role.level}
              </div>
              <h3 className="mb-6 text-xl font-bold text-white">{role.title}</h3>
              <ul className="space-y-4">
                {role.items.map((item, i) => (
                  <li key={i} className="flex items-center gap-3 text-[10px] font-bold tracking-wider text-zinc-400">
                    <div className="h-1.5 w-1.5 rounded-full bg-[#b4ff00]" />
                    {item}
                  </li>
                ))}
              </ul>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}
